import xw from 'xwind';
import styled from '@emotion/styled';

export const StyledImagePlaceholder = styled.img`
  ${xw`object-contain`}
  width: 226px;
`;

export const EmptyListWrapper = styled.div(
  xw`
    flex justify-center 
    flex-col items-center
  `,
);

export const Title = styled.p(
  xw`
    text-xl md:text-2xl text-gray-300 text-center
    leading-10 tracking-wider mt-8
  `,
);

export const ButtonEmptyList = styled.button(
  xw`
    bg-active py-2 px-4 text-white
    rounded-full mt-8 outline-none focus:outline-none
  `,
);
